import { ValueType } from '@trufla-technology/trumarket-react-design-system/lib/components/controls/MultiSelect';

export type SearchObject = {
  searchValue: string;
};
export type InternalNamePath = (string | number)[];
export type NamePath = string | number | InternalNamePath;
export type WorkingHours =
  | {
      from: string;
      to: string;
      day: 'SAT' | 'SUN' | 'MON' | 'TUES' | 'WED' | 'THUR' | 'FRI';
      timezone: string;
    }[]
  | undefined;

export type ResultObjectKey =
  | 'resultsAddress'
  | 'countryLongName'
  | 'countryShortName'
  | 'cityLongName'
  | 'cityShortName'
  | 'postalCodeLongName'
  | 'postalCodeShortName'
  | 'streetLongName'
  | 'streetShortName'
  | 'stateLongName'
  | 'stateShortName';

export type ResultObject = {
  [key in ResultObjectKey]?: string;
};
export type LocationResult = { data?: { key: string } | undefined };

export type BranchFormType = {
  name?: string;
  contractNumbers: string[];
  codes: ValueType | string[] | undefined;
  website: string | undefined;
  headquarter: boolean | undefined;
  companySocialMedia: boolean;
  mailboxes: { mail: string; type: string }[] | undefined;
  useGlobalWebsite: boolean;
  useGlobalPrimaryContact: boolean;
  useGlobalSocialMedia: boolean;
  phones: { number?: string | undefined; type: string | undefined }[];
  workingHours: {
    day: string;
    from: string;
    to: string;
    timezone: string;
    checkDay: boolean;
  }[];
  'primaryContact.name': string;
  'primaryContact.phones': {
    type?: string | undefined;
    number?: string | undefined;
  }[];
  'primaryContact.title': string;
  'primaryContact.email': string;
  'address.street': string;
  'address.suite': string;
  'address.country': string;
  'address.floor': string;
  'address.unitNumber': string | undefined;
  'address.city': string;
  'address.postalCode': string;
  'address.province': string;
  'address.fullAddress': string;
  longitude?: number | undefined;
  latitude?: number | undefined;
  'socialMedia.facebook'?: string;
  'socialMedia.twitter'?: string;
  'socialMedia.linkedIn'?: string;
  'socialMedia.youtube'?: string;
};

export const days = [
  'Saturday',
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
];
export const defaultDays = [
  { day: 'SAT' },
  { day: 'SUN' },
  { day: 'MON' },
  { day: 'TUES' },
  { day: 'WED' },
  { day: 'THUR' },
  { day: 'FRI' },
];
export const map: { [key in string]: number } = {
  SAT: 1,
  SUN: 2,
  MON: 3,
  TUES: 4,
  WED: 5,
  THUR: 6,
  FRI: 7,
};

export type LatLng = {
  lat: number | undefined;
  lng: number | undefined;
};

export type Address = {
  street: string | undefined;
  country: string | undefined;
  unitNumber?: string | undefined;
  city: string | undefined;
  postalCode: string | undefined;
  fullAddress?: string | undefined;
  suite?: string | undefined;
  floor?: string | undefined;
  province?: string | undefined;
};
